/* @flow */

export default class SignBuyerAutomaticBuyingRequest {
    companyId: number;
    investmentProfileId: number;
    returnSuccessUrl: string;
  
    constructor(companyId: number, investmentProfileId: number, returnSuccessUrl: string) {
      this.companyId = companyId;
      this.investmentProfileId = investmentProfileId;
      this.returnSuccessUrl = returnSuccessUrl;
    }
  }
  